import { LodgeEnquiryActionTypes, SetShapePayload } from './types';
import { action } from 'typesafe-actions';

export const setEnquiryAddress = (data: any) =>
  action(LodgeEnquiryActionTypes.SET_ENQUIRY_ADDRESS, data);

export const setShape = (payload: SetShapePayload) =>
  action(LodgeEnquiryActionTypes.SET_SHAPE, payload);

export const setMultipleShapes = (payload: SetShapePayload[]) =>
  action(LodgeEnquiryActionTypes.SET_MULTIPLE_SHAPES, payload);

export const setLiveArea = (payload: number | undefined) =>
  action(LodgeEnquiryActionTypes.SET_LIVE_AREA, payload);

export const setMultipleDrawMode = (payload: boolean) =>
  action(LodgeEnquiryActionTypes.SET_MULTIPLE_DRAW_MODE, payload);

export const removeShape = (id: number) =>
  action(LodgeEnquiryActionTypes.REMOVE_SHAPE, id);

export const clearShape = () => action(LodgeEnquiryActionTypes.CLEAR_SHAPE);

export const getGeocodeStart = (payload: any) =>
  action(LodgeEnquiryActionTypes.GET_GEOCODE_START, payload);
export const getGeocodeSuccess = (payload: any) =>
  action(LodgeEnquiryActionTypes.GET_GEOCODE_SUCCESS, payload);
export const getGeocodeFailure = (payload: any) =>
  action(LodgeEnquiryActionTypes.GET_GEOCODE_FAILURE, payload);

export const queryRecentLayerExtentStart = (layer: any) =>
  action(LodgeEnquiryActionTypes.QUERY_RECENT_LAYER_EXTENT_START, { layer });
export const queryRecentLayerExtentSuccess = (payload: any) =>
  action(LodgeEnquiryActionTypes.QUERY_RECENT_LAYER_EXTENT_SUCCESS, payload);

export const setDesignActivity = (data: any) =>
  action(LodgeEnquiryActionTypes.SET_ENQUIRY_ACT_DESIGN, data);

export const setExcavationActivity = (data: any) =>
  action(LodgeEnquiryActionTypes.SET_ENQUIRY_ACT_EXCAVATE, data);

export const setWorkingOnBehalfOfList = (data: any) =>
  action(LodgeEnquiryActionTypes.SET_WORKING_ON_BEHALF_OF_LIST, data);

export const setEarliestValidDate = (data: string) =>
  action(LodgeEnquiryActionTypes.SET_EARLIEST_VALID_DATE, data);

export const getEnquiryEssentialsStart = () =>
  action(LodgeEnquiryActionTypes.GET_ENQUIRY_ESSENTIALS_START);
export const getEnquiryEssentialsSuccess = () =>
  action(LodgeEnquiryActionTypes.GET_ENQUIRY_ESSENTIALS_SUCCESS);
export const getEnquiryEssentialsFailure = () =>
  action(LodgeEnquiryActionTypes.GET_ENQUIRY_ESSENTIALS_FAILURE);

export const clearLodgedEnquiry = () =>
  action(LodgeEnquiryActionTypes.CLEAR_LODGED_ENQUIRY);

export const getAssetOwnerCountStart = (data: any) =>
  action(LodgeEnquiryActionTypes.GET_ASSET_OWNERS_COUNT_START, data);
export const getAssetOwnerCountSuccess = (payload: any) =>
  action(LodgeEnquiryActionTypes.GET_ASSET_OWNERS_COUNT_SUCCESS, payload);
export const getAssetOwnerCountFailure = () =>
  action(LodgeEnquiryActionTypes.GET_ASSET_OWNERS_COUNT_FAILURE);

export const uploadEnquiryShapeStart = (file: File) =>
  action(LodgeEnquiryActionTypes.UPLOAD_ENQUIRY_SHAPE_START, file);
export const uploadEnquiryShapeSuccess = (payload: any) =>
  action(LodgeEnquiryActionTypes.UPLOAD_ENQUIRY_SHAPE_SUCCESS, payload);
export const uploadEnquiryShapeFailure = (payload: any) =>
  action(LodgeEnquiryActionTypes.UPLOAD_ENQUIRY_SHAPE_FAILURE, payload);

export const getDuplicateEnquiryStart = (payload: any) =>
  action(LodgeEnquiryActionTypes.GET_DUPLICATE_ENQUIRY_START, payload);
export const getDuplicateEnquirySuccess = (payload: any) =>
  action(LodgeEnquiryActionTypes.GET_DUPLICATE_ENQUIRY_SUCCESS, payload);
export const getDuplicateEnquiryFailure = (error: string) =>
  action(LodgeEnquiryActionTypes.GET_DUPLICATE_ENQUIRY_FAILURE, error);
export const clearDuplicateEnquiry = () =>
  action(LodgeEnquiryActionTypes.CLEAR_DUPLICATE_ENQUIRY);

export const getLastEnquiryStart = () =>
  action(LodgeEnquiryActionTypes.GET_LAST_ENQUIRY_START);
export const getLastEnquirySuccess = (payload: any) =>
  action(LodgeEnquiryActionTypes.GET_LAST_ENQUIRY_SUCCESS, payload);
export const getLastEnquiryFailure = (payload: any) =>
  action(LodgeEnquiryActionTypes.GET_LAST_ENQUIRY_FAILURE, payload);

export const lodgeNewEnquiryStart = (data: any) =>
  action(LodgeEnquiryActionTypes.LODGE_NEW_ENQUIRY_START, data);
export const lodgeNewEnquirySuccess = (payload: any) =>
  action(LodgeEnquiryActionTypes.LODGE_NEW_ENQUIRY_SUCCESS, payload);
export const lodgeNewEnquiryFailure = (payload: any) =>
  action(LodgeEnquiryActionTypes.LODGE_NEW_ENQUIRY_FAILURE, payload);

export const setPendingEquiriesAmount = (amount: number | undefined) =>
  action(LodgeEnquiryActionTypes.SET_PENDING_ENQUIRIES_AMOUNT, amount);

export const setBulkCreating = (flag: boolean | undefined) =>
  action(LodgeEnquiryActionTypes.SET_BULK_CREATING, flag);

export const setBulkBatchTotal = (num: number | undefined) =>
  action(LodgeEnquiryActionTypes.SET_BULK_BATCH_TOTAL, num);

export const setBulkBatchCreated = (num: number | undefined) =>
  action(LodgeEnquiryActionTypes.SET_BULK_BATCH_CREATED, num);

export const setSuccessEnquiryUserReference = (completed: any[]) =>
  action(LodgeEnquiryActionTypes.SET_SUCCESS_ENQUIRY_USER_REFERENCE, completed);

export const setMapErrorForLodgeEnquiryFail = (mapIds: number[]) =>
  action(LodgeEnquiryActionTypes.SET_MAP_ERROR_FOR_LODGE_ENQUIRY_FAIL, mapIds);

export const updateNewLodgedEquiries = (data: any) =>
  action(LodgeEnquiryActionTypes.UPDATE_NEW_LODGED_ENQUIRIES, data);

export const checkShapeWithinTeamStart = (payload: any) =>
  action(LodgeEnquiryActionTypes.CHECK_SHAPE_WITHIN_TEAM_START, payload);
export const checkShapeWithinTeamSuccess = (status: string) =>
  action(LodgeEnquiryActionTypes.CHECK_SHAPE_WITHIN_TEAM_SUCCESS, status);
export const checkShapeWithinTeamFailure = (error: string) =>
  action(LodgeEnquiryActionTypes.CHECK_SHAPE_WITHIN_TEAM_FAILURE, error);

export const setUseUploadedShapeUserReference = (payload: boolean) =>
  action(LodgeEnquiryActionTypes.USE_UPLOADED_SHAPE_USER_REFERENCE, payload);

export const setFailedEnquiries = (data: any) =>
  action(LodgeEnquiryActionTypes.SET_FAILED_ENQUIRIES, data);
export const clearFailedEnquiries = () =>
  action(LodgeEnquiryActionTypes.CLEAR_FAILED_ENQUIRIES);

export const getDraftStart = () =>
  action(LodgeEnquiryActionTypes.GET_DRAFT_START);
export const getDraftSuccess = (data: any) =>
  action(LodgeEnquiryActionTypes.GET_DRAFT_SUCCESS, data);
export const getDraftFailure = () =>
  action(LodgeEnquiryActionTypes.GET_DRAFT_FAILURE);

export const saveDraftStart = (data: any) =>
  action(LodgeEnquiryActionTypes.SAVE_DRAFT_START, data);
export const saveDraftSuccess = () =>
  action(LodgeEnquiryActionTypes.SAVE_DRAFT_SUCCESS);
export const saveDraftFailure = () =>
  action(LodgeEnquiryActionTypes.SAVE_DRAFT_FAILURE);

export const discardDraftStart = () =>
  action(LodgeEnquiryActionTypes.DISCARD_DRAFT_START);
export const discardDraftSuccess = () =>
  action(LodgeEnquiryActionTypes.DISCARD_DRAFT_SUCCESS);
export const discardDraftFailure = () =>
  action(LodgeEnquiryActionTypes.DISCARD_DRAFT_FAILURE);

export const getRestrictionStart = () =>
  action(LodgeEnquiryActionTypes.GET_RESTRICTIONS_START);
export const getRestrictionSuccess = (data: any) =>
  action(LodgeEnquiryActionTypes.GET_RESTRICTIONS_SUCCESS, data);
export const getRestrictionFailure = () =>
  action(LodgeEnquiryActionTypes.GET_RESTRICTIONS_FAILURE);
